/* RESPONSIBLE TEAM: team-reporting */
import Transform from '@ember-data/serializer/transform';

/**
 * A transform for arrays whose elements must always be strings.
 *
 * The backend stores report IDs as integers when folders are created by
 * SetupDefaultFolders (CustomReport#id is an ActiveRecord integer PK), but
 * the Update command requires string IDs (`array :reports, class: String`).
 * This transform coerces elements on both sides of the boundary so the
 * mismatch is transparent to the rest of the frontend.
 */
export default class StringArrayTransform extends Transform {
  deserialize(serialized: unknown): string[] {
    return Array.isArray(serialized) ? serialized.map(String) : [];
  }

  serialize(deserialized: unknown): string[] {
    return Array.isArray(deserialized) ? deserialized.map(String) : [];
  }
}
